import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  navtitle: "",
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setNavtitle: (state, action) => {
      state.navtitle = action.payload;
    },
  },
});

export const { setNavtitle } = layoutSlice.actions;

export const layoutReducer = layoutSlice.reducer;
